import { HttpRequest } from '@angular/common/http';
import { INTERCEPTOR_EXCEPT_URL } from '@core/configs';

export const filterInterceptorRequest = (req: HttpRequest<any>): boolean =>
  INTERCEPTOR_EXCEPT_URL.some(url => req.url.includes(url));
